import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n';
import {get,post} from '@/axios';
import '../src/utils/rem.js';
import Vant from 'vant';
import 'vant/lib/index.less';

Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.use(VueI18n);
Vue.use(Vant);
Vue.config.productionTip = false

const locale = localStorage.getItem('locale') || 'zh_cn';

const i18n = new VueI18n({
  locale: locale,
  messages: {
    en: require('./locales/en.json'),
    vi: require('./locales/vi.json'),
    ko: require('./locales/ko.json'),
    ja: require('./locales/ja.json'),
    zh_cn: require('./locales/zh.json')
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
